/**
 * PWA Service Worker Registration and Update Handling
 *
 * This module handles:
 * 1. Service worker registration for offline support
 * 2. Update detection and user prompts
 * 3. Cache management
 *
 * Works seamlessly with both:
 * - Web/PWA: Uses browser service worker API
 * - Capacitor: Service worker still works in WebView
 */

import { Workbox } from "workbox-window";

export function registerSW() {
  // Only register service worker in production builds
  // In dev mode, the SW file doesn't exist and would cause errors
  if (import.meta.env.PROD && "serviceWorker" in navigator) {
    const wb = new Workbox(`${import.meta.env.BASE_URL}sw.js`);

    // Listen for the 'waiting' event - this means a new version is available
    wb.addEventListener("waiting", () => {
      const shouldUpdate = confirm(
        "A new version is available! Click OK to update.",
      );

      if (shouldUpdate) {
        // Tell the waiting service worker to skip waiting and become active
        wb.messageSkipWaiting();
      }
    });

    // Listen for the 'controlling' event - this means the new SW has taken over
    wb.addEventListener("controlling", () => {
      // Reload the page to load the new version
      window.location.reload();
    });

    // Register the service worker
    wb.register()
      .then((registration) => {
        // Check for updates every hour
        setInterval(
          () => {
            registration?.update();
          },
          60 * 60 * 1000,
        );
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });
  }
}
